import React, { useEffect, useState } from 'react';
import ArrowUpIcon from 'assets/icons/arrow-up.svg';
import ArrowDownIcon from 'assets/icons/arrow-down.svg';
import DownloadIcon from 'assets/icons/download-icon.svg';
import ViewIcon from 'assets/icons/view-icon.svg';
import VideoIcon from 'assets/icons/video-icon.svg';
import VideoIconWhite from 'assets/icons/video-icon-white.svg';
import DocumentIcon from 'assets/icons/document-icon.svg';
import ImgIcon from 'assets/icons/img-icon.svg';
import ImgIconWhite from 'assets/icons/img-icon-white.svg';
import SettingsIconWhite from 'assets/icons/settings-icon-white.svg';
import SettingsIconBlack from 'assets/icons/settings-icon-black.svg';
import DocumentIconWhite from 'assets/icons/document-icon-white.svg';
import Modal from 'react-modal';
import { MEDIA_TYPES } from 'types';
import { MediaObject } from '../../../../pages/dashboard/slice/types';
import { pdfjs } from 'react-pdf';
import { useTranslation } from 'react-i18next';
import { translations as _ } from 'locales/translations';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';
import Ellipsis from 'react-ellipsis-component';
import Checkbox from 'app/components/Form/Checkbox';
import ModalShowMedia from './ModalShowMedia';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

Modal.setAppElement(document.getElementById('root'));

export default function MediaItem(props: any) {
  const { mediaKey, mediaElements, menuDeleteOpen } = props;

  const [isFolderOpen, setIsFolderOpen] = useState(false);
  const [isSubfolderOpen, setIsSubfolderOpen] = useState();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [currentElement, setCurrentElement] = useState<MediaObject | null>(
    null,
  );
  const [parentCheck, setParentCheck] = useState(false);
  const [parentSubCheck, setParentSubCheck] = useState(false);
  const { t } = useTranslation();
  const mediaKeyTranslations = _.mediakey;
  const { register, getValues, setValue } = useFormContext();

  useEffect(() => {
    if (menuDeleteOpen) {
      setIsFolderOpen(true);
    }
  }, [menuDeleteOpen]);

  function setAll() {
    setParentCheck(!parentCheck);
  }
  function setSubMediaAll(element) {
    setParentSubCheck(!parentSubCheck);
    let newObj = {};
    if (getValues(`files`)) {
      Object.keys(getValues(`files`)).forEach(d => {
        newObj[d] = getValues(`files`)[d].map((m, i) => {
          if (mediaKey === d) {
            const id = mediaElements.medias[i].id;
            return {
              ...m,
              value: !parentCheck ? `${id}` : false,
            };
          } else {
            return m;
          }
        });
      });
      setValue(`files`, newObj);
    }
  }

  function getImageType(name, isWhite = false) {
    switch (name.split('.').pop().toLowerCase()) {
      case 'pdf':
        return isWhite ? DocumentIconWhite : DocumentIcon;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return isWhite ? ImgIconWhite : ImgIcon;
      case 'exe':
        return isWhite ? SettingsIconWhite : SettingsIconBlack;
      default:
        return isWhite ? VideoIconWhite : VideoIcon;
    }
  }

  function returnExtention(element) {
    return element.split('.').pop().toLowerCase();
  }

  function formatMediaKey(mediaKey) {
    return (
      t(mediaKeyTranslations[mediaKey.toLowerCase()]) ||
      mediaKey.charAt(0) + mediaKey.slice(1).toLowerCase()
    );
  }

  function handleOpenSubfolder(elementId) {
    if (isSubfolderOpen !== elementId) {
      setIsSubfolderOpen(elementId);
    } else {
      setIsSubfolderOpen(undefined);
    }
  }

  return (
    <div className="media-item">
      <div className="media-item-container">
        <div className="media-item-header">
          {menuDeleteOpen && (
            <div className="media-item-header-control">
              <Checkbox
                label={''}
                id={mediaKey}
                onClick={() => setAll()}
                defaultChecked={parentCheck}
              />
            </div>
          )}
          <div className="media-item-header-content">
            <img
              alt="arrow"
              src={isFolderOpen ? ArrowUpIcon : ArrowDownIcon}
              className="arrow"
              onClick={() => setIsFolderOpen(!isFolderOpen)}
            />
            <h4 onClick={() => setIsFolderOpen(!isFolderOpen)}>
              {formatMediaKey(mediaKey)}{' '}
              <span className="count-files">
                {mediaElements.medias?.length ||
                  mediaElements?.subfolder?.length}
              </span>
            </h4>
            <div className="details">
              <p className="zip">.zip</p>
              <p className="files">
                {`${
                  mediaElements.medias?.length ||
                  mediaElements?.subfolder?.length
                } files`}
              </p>
              <a href={mediaElements.archive} download>
                <img
                  alt="download"
                  src={DownloadIcon}
                  className={cx('download', {
                    hidden: mediaKey === MEDIA_TYPES.VIDEO,
                  })}
                />
              </a>
            </div>
          </div>
        </div>
        {isFolderOpen && (
          <>
            {mediaElements?.subfolder?.map((element, index) => {
              return (
                <div key={element.code} className="media-item-container-sub">
                  <div className="media-item-header">
                    {menuDeleteOpen && (
                      <div className="media-item-header-control">
                        <Checkbox
                          label={''}
                          id={element.code}
                          onClick={() => setSubMediaAll(element)}
                          defaultChecked={parentCheck}
                        />
                      </div>
                    )}
                    <div className="media-item-header-content-sub">
                      <img
                        alt="arrow"
                        src={
                          isSubfolderOpen === element.id
                            ? ArrowUpIcon
                            : ArrowDownIcon
                        }
                        className="arrow"
                        onClick={() => handleOpenSubfolder(element.id)}
                      />
                      <h4 onClick={() => handleOpenSubfolder(element.id)}>
                        {formatMediaKey(element.code)}
                        <span className="count-files">
                          {element.medias?.length}
                        </span>
                      </h4>
                      <div className="details">
                        <p className="zip">.zip</p>
                        <p className="files">
                          {element.medias?.length}
                          files
                        </p>
                        <a href={element.archive} download>
                          <img
                            alt="download"
                            src={DownloadIcon}
                            className={cx('download', {
                              hidden: mediaKey === MEDIA_TYPES.VIDEO,
                            })}
                          />
                        </a>
                      </div>
                    </div>
                  </div>

                  {isSubfolderOpen === element.id &&
                    element?.medias?.map((subMedia, index) => {
                      return (
                        <div
                          className="media-item-content"
                          key={'content-' + subMedia.code}
                        >
                          {menuDeleteOpen && (
                            <div className="media-item-content-action">
                              <Checkbox
                                label={''}
                                id={subMedia.id}
                                key={subMedia.code}
                                {...register(
                                  `files.${mediaKey}.${element.code}.${index}.value` as `files.mediakey.index.value`,
                                )}
                                value={subMedia.id}
                              />
                            </div>
                          )}
                          <div className="media-item-content-detail">
                            <img
                              alt="documentType"
                              className="document"
                              src={getImageType(subMedia.name)}
                            />
                            <div className="elipsis">
                              <Ellipsis
                                ellipsis
                                text={subMedia.name}
                                maxLine={2}
                              />
                            </div>
                            {!subMedia.name.includes('.exe') &&
                            returnExtention(subMedia.name) !== 'step' &&
                            mediaKey !== MEDIA_TYPES.VIDEO &&
                            !subMedia.link_text ? (
                              <img
                                onClick={() => {
                                  setCurrentElement(subMedia);
                                  setIsOpenModal(true);
                                }}
                                alt="download"
                                src={ViewIcon}
                                className="viewIcon"
                              />
                            ) : null}
                            {!subMedia.link_text ? (
                              <a href={subMedia.link_value} download>
                                <img
                                  alt="download"
                                  className="download"
                                  src={DownloadIcon}
                                />
                              </a>
                            ) : (
                              <a
                                href={subMedia.link_value}
                                target={'_BLANK'}
                                rel="noreferrer"
                                className="link-vimeo-mobile"
                              >
                                <img
                                  alt="link vimeo"
                                  className="link vimeo"
                                  src={ViewIcon}
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            })}

            {mediaElements?.medias?.map((element, index) => {
              return (
                <div
                  className="media-item-content"
                  key={'content-' + element.id}
                >
                  {menuDeleteOpen && (
                    <div className="media-item-content-action">
                      <Checkbox
                        label={''}
                        id={element.id}
                        key={element.id}
                        {...register(
                          `files.${mediaKey}.${index}.value` as `files.mediakey.index.value`,
                        )}
                        value={element.id}
                      />
                    </div>
                  )}
                  <div className="media-item-content-detail">
                    <img
                      alt="documentType"
                      className="document"
                      src={getImageType(element.name)}
                    />
                    <div className="elipsis">
                      <Ellipsis ellipsis text={element.name} maxLine={2} />
                    </div>
                    {!element.name.includes('.exe') &&
                      returnExtention(element.name) !== 'step' &&
                      !element.link_text && (
                        <img
                          onClick={() => {
                            setCurrentElement(element);
                            setIsOpenModal(true);
                          }}
                          alt="viewIcon"
                          src={ViewIcon}
                          className="viewIcon"
                        />
                      )}
                    {!element.link_text ? (
                      <a href={element.link_value} download>
                        <img
                          alt="download"
                          className="download"
                          src={DownloadIcon}
                        />
                      </a>
                    ) : null}
                    {element.link_text ? (
                      <a
                        href={element.link_value}
                        target={'_BLANK'}
                        rel="noreferrer"
                        className="link-vimeo-mobile"
                      >
                        <img
                          alt="link vimeo"
                          className="link vimeo"
                          src={ViewIcon}
                        />
                      </a>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </>
        )}
        {currentElement && isOpenModal && (
          <ModalShowMedia
            setCurrentElement={setCurrentElement}
            currentElement={currentElement}
            mediaKey={mediaKey}
            mediaElements={mediaElements}
            isOpenModal={isOpenModal}
            setIsOpenModal={setIsOpenModal}
          />
        )}
      </div>
    </div>
  );
}
